<template>
  <section id="app">
    <section v-if="loading">
      <m-loading text="努力查询中..."></m-loading>
    </section>

    <section v-else>
      <!-- 支付中 -->
      <section v-if="payStatus === 0">
        <img
          class="status-icon"
          src="~assets/images/error.png"
          alt="">
        <p class="status-tips">
          木有找到支付结果... <br>
          请稍后再查询 <br>
        </p>
      </section>

      <!-- 成功 -->
      <section v-if="payStatus === 1">
        <img
          class="status-icon"
          src="~assets/images/success.png"
          alt="">
        <p
          class="status-tips"
          v-if="expired"
          >
          您的帐户有效期延长至 <br>
          {{expired}} <br>
          请登录美甲帮店务通“个人设置>我的帐户”中查看 <br>
        </p>

        <p class="status-tips">
          购买成功~请用这个手机号码注册美甲帮店务通！<br>
          系统将自动为您激活账户，账户有效期从激活当日开始计算。<br>
          点击
          <a
            href="//mjb8.cn/00UH"
            >
            http://mjb8.cn/00UH
          </a>
          下载美甲帮店务通！
        </p>
      </section>

      <!-- 失败 -->
      <section v-if="payStatus === 2">
        <img
          class="status-icon"
          src="~assets/images/error.png"
          alt="">
        <p class="status-tips">
          出错啦～您的支付没有成功！请稍候再试！<br>
          如有疑问，请拨打客服电话 <br>
          <a
            href="400-182-5818"
            class="tel"
            >
            400-182-5818
          </a>
        </p>
      </section>
    </section>
  </section>
</template>

<script>

import api from 'api'
import store from 'store'

import loading from 'components/loading'

export default {
  name: 'Result',

  components: {
    mLoading: loading,
  },

  data() {
    return {
      payStatus: 0, // 1成功 2失败
      shopExpireDate: null,

      // 状态
      loading: true,
    }
  },

  computed: {
    expired() {
      if (this.shopExpireDate) {
        const date = new Date(+this.shopExpireDate)
        return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`
      }

      return null
    },
  },

  methods: {

  },

  created() {
    if (document.body.classList) {
      document.body.classList.add('white')
    }

    const tradeInfo = this.$route.query // 从url取出支付宝回跳参数
    const token = store.token
    console.log(tradeInfo, token)

    // TODO: 验证trade token合法

    api.get('/pay/resultCheck', {
      params: {
        token,
        orderSn: tradeInfo.out_trade_no,
      },
    })
    .then(({data}) => {
      this.payStatus = data.payStatus
      // this.payStatus = 1
      this.shopExpireDate = data.shopExpireDate

      this.loading = false
    })
    .catch((error) => {
      alert(error.errMsg || '查询支付结果失败')
    })
  },

  destroyed() {
    if (document.body.classList) {
      document.body.classList.remove('white')
    }
  },
}

</script>

<style lang="scss" scoped>

.status-icon {
  width: 87px;
  height: 100px;
  display: block;
  margin-top: 70px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 24px;
}

.status-tips {
  text-align: center;
  font-size: 14px;
  color: #262626;
  line-height: 20px;

  .tel {
    color: inherit;
  }
}

</style>


// WEBPACK FOOTER //
// Result.vue?3aeb64ee